module.exports = __webpack_public_path__ + "img/meat_rib.082eeb88.jpg";